import { Component, OnInit, Input } from '@angular/core';
import { TaskSaveService } from '../../../task/services/task-save.service';
import { AgendaService } from 'app/modules/doctors-view/services/agenda.service';
import { AddTimeComponent } from 'app/modules/task/components/add-time/add-time.component';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-tareas-tab',
    templateUrl: './tareas-tab.component.html',
    styleUrls: ['./tareas-tab.component.scss'],
    standalone: false
})
export class TareasTabComponent implements OnInit {

  @Input() dataSource: MatTableDataSource<any>;
  @Input() DateTaskCount: any;
  @Input() displayedColumns: any;
  public empresaId: number;

  constructor(
    public taskService: TaskSaveService,
    public agendaService: AgendaService,
    public dialog: MatDialog,
    public sharedService: SharedService) { }


  ngOnInit(): void {
    this.empresaId = JSON.parse(localStorage.getItem('Empresa'));
  }


  GoToEmployee(trabajadorId): void {
    this.taskService.GoToEmployee(trabajadorId);
  }

  PrintDocument(task): void {
    this.taskService.PrintDocument(task);
  }

  addTimePopup(task): void {
    const dialogRef = this.dialog.open(AddTimeComponent,
      {
        width: '',
        data: task
      });

    dialogRef.componentInstance.taskService.savedTaskSelection.subscribe(() => {
      this.taskService.refershTabList.emit();
    });
  }

  deleteTask(task): void {
    const isMarkedTask = task.tipo ? this.taskService.validateMarkedTask(task.tipo) : false;
    if (isMarkedTask) {
      this.callDeleteTask(task);
    } 
    else {
      this.openConfirmDialogForDelete(task);
    } 
  }
  openConfirmDialogForDelete(task): void {
    const message = `¿Eliminar definitivamente esta tarea?`;
    const dialogData = new ConfirmDialogModel('Confirmar acción', message);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(responce => {
      if (responce) {
        this.callDeleteTask(task);
      }
    });
  }

  callDeleteTask(task: any): void {
    this.taskService.deleteTask(task.tareaId).subscribe(res => {
      if (res.code === 0) {
        this.taskService.refershTabList.emit();
        this.agendaService.getTareasHoyCount(this.empresaId);
        this.sharedService.ShowSnackBar('Borrado exitosamente', '', 2500);
      } else {
        this.sharedService.ShowSnackBar('eliminar falla', '', 2500);
      }
    }, err => {
      this.sharedService.ShowSnackBar('eliminar falla', '', 2500);
    });
  }

}
